import { useCallback, useRef, useState } from 'react';
import { findUnfilledBlanks } from './unfilledBlanks';

interface BlanksPrompt {
    blanks: string[];
    resolve: (send: boolean) => void;
}

// Feeds ChatInput's confirmSubmit: a message with [ ] blanks waits for the staff's answer.
export function useUnfilledBlanksGuard() {
    const [prompt, setPrompt] = useState<BlanksPrompt | null>(null);
    const promptOpenRef = useRef(false);

    const confirmSubmit = useCallback((text: string): Promise<boolean> => {
        const blanks = findUnfilledBlanks(text);
        if (blanks.length === 0) return Promise.resolve(true);
        // A second Enter while the prompt is open must not queue another send.
        if (promptOpenRef.current) return Promise.resolve(false);
        promptOpenRef.current = true;
        return new Promise((resolve) => setPrompt({ blanks, resolve }));
    }, []);

    const answer = useCallback(
        (send: boolean) => {
            promptOpenRef.current = false;
            prompt?.resolve(send);
            setPrompt(null);
        },
        [prompt]
    );

    return { confirmSubmit, blanks: prompt?.blanks ?? null, answer };
}
